export const bookingsHc = {
  firstCheckinSend: {
    badge: "Automação",
    title: "Quando as informações de chegada são enviadas?",
    desc: "Ative cada evento e decida <strong>quando</strong> é enviado: quando <strong>um hóspede</strong> conclui o seu registro, ou apenas quando <strong>todos</strong> os hóspedes da reserva concluem o registro.",
    loading: "Carregando configurações…",
    welcomeName: "Mensagem de boas-vindas",
    welcomeSub: "A mensagem de boas-vindas que o hóspede recebe logo após concluir o seu registro.",
    documentName: "Documento assinado de políticas",
    documentSub: "É o documento que o hóspede assina no processo de registro. Enviamos em PDF para que ele o tenha no seu WhatsApp ou e-mail.",
    timingIndividual: "Quando um hóspede conclui o seu registro",
    timingAll: "Quando todos os hóspedes da reserva concluem o registro",
    timingQuestion: "Quando é enviado?",
    eventOffNote: "Este evento não será enviado automaticamente.",
    infoBox: "As alterações são salvas automaticamente. A chave de acesso, quando a acomodação tem fechadura inteligente, segue a sua própria configuração.",
    loadError: "Não foi possível carregar a configuração.",
    saveError: "Não foi possível salvar a configuração. Tente novamente.",
  },
  checkinProcess: {
    colEmail: "E-mail",
    colSendDate: "Data de envio",
    colStatus: "Status",
    unspecified: "Não especificado",
    complete: "Completo",
    pending: "Pendente",
  },
  listBookings: {
    title: "Lista de check-ins",
    subtitle: "Registro de entradas dos seus hóspedes",
    accommodation: "Acomodação",
    all: "Todos",
    from: "De",
    to: "Até",
    search: "Buscar",
    today: "Hoje",
    noDate: "Sem data",
    clear: "Limpar",
    exporting: "Exportando...",
    exportCheckins: "Exportar",
    ricevutaBtn: "Recibo da polícia",
    ricevutaTitle: "Recibo da polícia italiana",
    ricevutaHint: "O recibo oficial do Alloggiati Web com todos os check-ins enviados em cada dia. Um dia baixa um PDF; vários, um ZIP com um PDF por dia (máximo 31).",
    ricevutaFrom: "De",
    ricevutaTo: "Até",
    ricevutaAccount: "Conta da polícia",
    ricevutaDownload: "Baixar PDF",
    ricevutaDownloading: "Baixando…",
    ricevutaCancel: "Cancelar",
    ricevutaError: "Não foi possível baixar o recibo.",
    noAccommodation: "Sem acomodação",
    noReservation: "Sem reserva",
    travelerReport: "Boletim de viajante (Mossos)",
    noRecords: "Sem registros",
    noRecordsFiltered: "Nenhum registro foi encontrado com os filtros aplicados.",
    noCheckinsTitle: "Ainda não há check-ins registrados",
    noCheckinsSub: "Quando os seus hóspedes concluírem o check-in, você os verá aqui com todas as suas informações.",
    excelSuccess: "Check-ins baixados em Excel",
    excelSuccessTitle: "Exportação concluída",
    excelError: "Não conseguimos exportar os check-ins",
    errorTitle: "Erro",
    listingNotIdentified: "Não foi possível identificar o anúncio do check-in",
    comprobanteNotAvailable: "O comprovante ainda não está disponível para este check-in",
    comprobanteDownloadError: "Não foi possível baixar o comprovante",
  },
  modalFirstCheckin: {
    loading: "Carregando...",
    sendingLinkWait: "Enviando o link de check-in, por favor aguarde...",
    phoneRequired: "Para continuar, você deve inserir o número do WhatsApp",
    sendingLink: "Enviando link ...",
    almostThere: "Falta pouco, por favor aguarde...",
    sentSuccess: "Enviado com sucesso",
    sendError: "Erro ao enviar o check-in",
    title: "Experimente agora um processo de check-in com o seu próprio telefone",
    enterWhatsapp: "Insira o seu número do WhatsApp",
    invalidNumber: `Número inválido. Certifique-se de incluir o prefixo "+".`,
    skip: "Pular",
    sendFirstCheckin: "Enviar o seu primeiro check-in",
    sendCheckin: "Enviar check-in",
  },
  tableRetriveCheckinPending: {
    colEmail: "E-mail",
    colSendDate: "Data de envio",
    colStatus: "Status",
    unspecified: "Não especificado",
    complete: "Completo",
    pending: "Pendente",
    emptyMessage: "Você ainda não tem check-ins em andamento",
  },
  rerservationModal: {
    night: "noite",
    nights: "noites",
    minStayBanner: "O intervalo selecionado tem uma restrição de estadia mínima de {count} {nights} (regra OTA). Noites selecionadas: {selected}.",
    freeUnits: "Unidades livres: {count}",
    noAvailabilityDetailed: "Sem disponibilidade para estas datas. {details}",
    noAvailability: "Sem disponibilidade para estas datas.",
    hotelAvailabilityError: "Não foi possível validar a disponibilidade (hotel).",
    minStayWarning: "Para o dia de chegada é necessário um mínimo de {count} noites. Você selecionou {selected}.",
    notEnoughAvailability: "Não há disponibilidade suficiente. Unidades livres: {count}.",
    noAvailabilityDates: "Não há disponibilidade para as datas selecionadas.",
    departureAfterArrival: "A saída deve ser posterior à chegada.",
    close: "Fechar",
    noMatches: "Sem correspondências",
    noAccommodations: "Não há acomodações",
    searchingGuests: "Buscando hóspedes...",
    noName: "Sem nome",
    priceLocked: "Não é possível modificar o preço da reserva.",
    otaMoveHint: "Pode movê-la para outro alojamento do mesmo anúncio; o canal é avisado.",
    otaMoveHintCuenta: "Pode movê-la para qualquer um dos seus alojamentos. Se for do mesmo anúncio, o canal é avisado.",
    otaRelocateNote: "É outro anúncio: é movida no WACheckin, mas o canal continuará a tê-la no alojamento onde foi vendida. As alterações e o cancelamento continuarão a chegar-lhe.",
    extrasTitle: "Outras opções",
    extrasSub: "Marque o que cobra e o desconto que aplica",
    quoteTitle: "O que cobra a sua reserva direta",
    quoteHint: "Marque o que quer cobrar nesta reserva. As noites vão sempre.",
    quoteOptions: "1 por marcar | {count} por marcar",
    quoteNoExtras: "Este alojamento não tem limpeza nem encargos configurados na sua reserva direta.",
    quoteStay: "Estadia · {count} noite | Estadia · {count} noites",
    quoteExtraGuest: "Hóspede extra | {count} hóspedes extra",
    quoteDiscount: "Descontos e promoções",
    quoteOccupancyDiscount: "Desconto por ocupação",
    quoteCleaning: "Taxa de limpeza",
    quoteTotal: "Total",
    quoteUse: "Usar este preço",
    quoteNoRate: "Sem tarifa para essas datas: escreva o preço à mão.",
    quoteLinePrice: "Preço deste alojamento",
    unitsAdd: "Adicionar outro alojamento do anúncio…",
    unitsGuests: "Hóspedes neste alojamento",
    unitsRemove: "Retirar da reserva",
    unitsGroupError: "Não foi possível criar a reserva de vários alojamentos.",
    resendTitle: "Reenviar mensagem de confirmação",
    resendSub: "Reenvia o modelo de confirmação ao hóspede.",
    resendNote: "Ao modificar a reserva, <strong>o modelo de confirmação será reenviado</strong> para esta reserva.",
    saving: "Salvando...",
  },
};
